import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putBusScheduleSimulate = ({ bus_course_id, id, ...data }) => {
  return api.put(
    `/admin/bus-courses-v2/${bus_course_id}/schedules/simulate/${id}`,
    data
  );
};

export const putBusScheduleSimulateQueryOptions = data => {
  return queryOptions({
    queryKey: ["put-bus-schedule-simulate", data],
    queryFn: () => putBusScheduleSimulate(data),
  });
};

export const usePutBusScheduleSimulateQuery = ({
  queryConfig,
  ...data
} = {}) => {
  return useQuery({
    ...putBusScheduleSimulateQueryOptions(data),
    ...queryConfig,
  });
};
